import React from 'react'

import RadioQuestion from './RadioQuestion'
import CheckBoxQuestion from './CheckBoxQuestion'
import TextQuestion from './TextQuestion'
import NumericQuestion from './NumericQuestion'
import SelectQuestion from './SelectQuestion'

export default class Question extends React.Component {
  render() {
    const { question, onChange, state, originalState, completed, answermap, isIntroQuestions, analyse, feedback } = this.props

    if (!question) {
      return null
    }

    switch (question.optionType) {
      case 'RADIO':
        return (
          <RadioQuestion
            key={question.id}
            data={question}
            state={state}
            originalState={originalState}
            onChange={(e, optionIds) => onChange(e, optionIds)}
            completed={completed}
            answermap={answermap}
            isIntroQuestions={isIntroQuestions}
            isExtraQuestion={true}
            feedback={feedback}
            analyse = {analyse}
          />
        )
      case 'RADIO_WITH_EXPLANATION':
        return (
          <RadioQuestion
            key={question.id}
            data={question}
            state={state}
            originalState={originalState}
            onChange={(e, optionIds) => onChange(e, optionIds)}
            completed={completed}
            answermap={answermap}
            isIntroQuestions={isIntroQuestions}
            isExtraQuestion={true}
            analyse = {analyse}
          />
        )
      case 'CHECKBOX':
        return (
          <CheckBoxQuestion
            key={question.id}
            data={question}
            state={state}
            originalState={originalState}
            onChange={(e, optionIds) => onChange(e, optionIds)}
            completed={completed}
            answermap={answermap}
            isIntroQuestions={isIntroQuestions}
            isExtraQuestion={true}
            analyse = {analyse}
            feedback={feedback}
          />
        )
      case 'TEXT':
        return (
          <TextQuestion
            key={question.id}
            data={question}
            state={state}
            onChange={(e, optionId) => onChange(e, optionId)}
            answermap={answermap}
            isIntroQuestions={isIntroQuestions}
            isExtraQuestion={true}
            analyse = {analyse}
            feedback={feedback}
          />
        )
      case 'NUMERIC':
        return (
          <NumericQuestion
            key={question.id}
            data={question}
            state={state}
            originalState={originalState}
            onChange={(e, optionId) => onChange(e, optionId)}
            answermap={answermap}
            isIntroQuestions={isIntroQuestions}
            isExtraQuestion={true}
            completed={completed}
            analyse = {analyse}
            feedback={feedback}
          />
        )
      case 'SELECT':
        return (
          <SelectQuestion
            key={question.id}
            data={question}
            state={state}
            originalState={originalState}
            onChange={(e, optionId) => onChange(e, optionId)}
            completed={completed}
            answermap={answermap}
            isIntroQuestions={isIntroQuestions}
            isExtraQuestion={true}
            analyse = {analyse}
            feedback={feedback}
          />
        )
      default:
        console.log('Er mist een optie: ' + question.optionType)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Question.js